class SwiperComponent extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.currentMode = null;
    this._resizeHandler = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.initSlider();
    window.addEventListener("resize", this._resizeHandler);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this._resizeHandler);
    this.destroySlider();
  }

  handleResize() {
    const newMode = this.getMode();
    if (newMode !== this.currentMode) {
      this.destroySlider();
      this.initSlider();
    }
  }

  getMode() {
    return window.innerWidth >= 850 ? "desktop" : "tablet";
  }

  // ✅ Helper: find arrows even if outside swiper-component
  findArrow(container, selector) {
    return (
      container.querySelector(selector) ||
      container.closest(".section, .collection, .page-width")?.querySelector(selector)
    );
  }

  getDesktopConfig(container) {
    const nextEl = this.findArrow(container, ".swiper-button-next");
    const prevEl = this.findArrow(container, ".swiper-button-prev");

    return {
      slidesPerView: Number(this.dataset.desktopSlides) || "auto",
      spaceBetween: Number(this.dataset.desktopSpacebetween) || 20,
      centeredSlides: this.dataset.desktopCenteredslides === "true",
      loop: this.dataset.desktopLoop === "true",
      navigation:
        this.dataset.desktopArrows === "true"
          ? {
              nextEl,
              prevEl,
            }
          : {},
      pagination:
        this.dataset.desktopPagination === "true"
          ? {
              el:
                container.querySelector(".swiper-pagination") ||
                container.closest(".section, .collection")?.querySelector(".swiper-pagination"),
              type: "progressbar",
            }
          : {},
    };
  }

  getTabletConfig(container) {
    const nextEl = this.findArrow(container, ".swiper-button-next");
    const prevEl = this.findArrow(container, ".swiper-button-prev");

    return {
      slidesPerView: Number(this.dataset.mobileSlides) || "auto",
      spaceBetween: Number(this.dataset.mobileSpacebetween) || 10,
      centeredSlides: this.dataset.mobileCenteredslides === "true",
      loop: this.dataset.mobileLoop === "true",
      navigation:
        this.dataset.mobileArrows === "true"
          ? {
              nextEl,
              prevEl,
            }
          : {},
      pagination:
        this.dataset.mobilePagination === "true"
          ? {
              el:
                container.querySelector(".swiper-pagination") ||
                container.closest(".section, .collection")?.querySelector(".swiper-pagination"),
              type: "progressbar",
            }
          : {},
    };
  }

  initSlider() {
    const mode = this.getMode();
    this.currentMode = mode;

    let container = null;
    if (
      (mode === "desktop" && this.classList.contains("swiper--desktop")) ||
      (mode !== "desktop" && this.classList.contains("swiper--tablet"))
    ) {
      container = this;
    }

    if (!container) {
      // console.warn(`No swiper element found for mode: ${mode}`);
      return;
    }

    const config =
      mode === "desktop"
        ? this.getDesktopConfig(container)
        : this.getTabletConfig(container);

    this.swiperInstance = new Swiper(container, config);
  }

  destroySlider() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}

customElements.define("swiper-component", SwiperComponent);
